import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { __EventDispatcher, __Lang, __Utils } from '../../../../_core/core';
import { store } from '../../../../_core/core.Store';
import { action_setSelectedNumbers } from '../../../../_core/store/actions/actions.Game';
import { EventClass, EventType } from '../../../config/Events';
import { NO_TOTAL_NUMBERS, NO_OF_ITEMS, NO_OF_ROWS } from '../../../config/Game';
import './Popup.Bet.styles.css';

const Y_DISTANCE = 12.500;
const X_DISTANCE = 10;
const TOP_DISTANCE = 0;

const BetPopup = (_props?: any) => {

  const [selectedNumbers, setSelectedNumbers ] = useState<number[]>([]);
  const [ canBuy, setCanBuy ] = useState<boolean>(false);

  useEffect(() => {
    setSelectedNumbers(_props.GAMEPLAY.selectedNumbers);
  }, [_props.GAMEPLAY.selectedNumbers]);

  useEffect(() => {
    setCanBuy( selectedNumbers.length === 0 || selectedNumbers.length % NO_OF_ROWS !== 0)
  }, [selectedNumbers]);

  const closePopup = () => {
    __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.CLEAR_POPUP, {});
  }

  const calculatePosition = (index: number) => {
    const top = TOP_DISTANCE + Math.floor(index/NO_OF_ITEMS) * Y_DISTANCE;
    const left = Math.floor(index%NO_OF_ITEMS) * X_DISTANCE ;

    return { top, left };
  }
  
  const calculateClasses = (number: number): string[] => {
    let _classes = ['game-ball-wrapper', 'is-button', 'is-drawn', 'is-placed'];
    
    if(selectedNumbers.includes(number)) {
      _classes.push('is-selected');
    }
    return _classes;
  }

  const calculateColor = (number: number): string[] => {
    let _classes = ['game-ball-number', 'game-ball-number-gradient'];

    if(selectedNumbers.includes(number)) {
      _classes.push(__Utils.generateNumberColor(number));
    }

    return _classes;
  }

  const clear = () => {
    setSelectedNumbers([]);
  }

  const selectNumber = (_number: number) => {
    const _isSelected = selectedNumbers.includes(_number);

    if(_isSelected) {

    }else {
      setSelectedNumbers([
        ...selectedNumbers,
        _number,
      ]);
    }
  }

  const buyNext = () => {
    if(canBuy) return;
 
    action_setSelectedNumbers(selectedNumbers)(store.dispatch);
    closePopup();
  }
 
  return (
    <div className="screen-blocker">
      <div className="popup-bet-box">
        <button className="close-btn" onClick={ () => closePopup() }>x</button>
        <h4 className="popup-header">
          { selectedNumbers.length } { __Lang.translate('n:play.numbersPicked') }
        </h4>
        
        <div className="game-selection-pick-numbers">
          <div className="gameplay-options-new">
            <button className="btn btn-clear" onClick={ () => clear() }>{ __Lang.translate('n:play.clear') }</button>
          </div>
          <div className="gameplay-selection-grid show-icons">
            { 
              [...new Array(NO_TOTAL_NUMBERS)].map((_el, _index) => (
                <div 
                 key={`PickNewNumbers${_index}`}
                  className={ calculateClasses(_index+1).join(' ') } 
                  onClick={ () => selectNumber(_index + 1) }
                  style={ { top: calculatePosition(_index).top + '%', left: calculatePosition(_index).left + '%' } }
                  data-id={ _index + 1}>
                  <span className="game-ball">
                    <span ng-if="isDrawn" className={ calculateColor(_index + 1).join(' ') }>
                      <span className="ng-binding">{ _index + 1 }</span>
                    </span>
                  </span>
                </div>
              ))  
            }
          </div>
        </div>
        
        <div className="popup-footer">
          <button className="btn-primary-new ng-scope" disabled={ canBuy } onClick={ () => buyNext() }>{ __Lang.translate('n:play.done') }</button>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state: any) => {
  return {
    GAMEPLAY: state.game.GAMEPLAY, 
  };
}
 
export default connect(mapStateToProps, {})(BetPopup);